<template>
  <div class="modal-password-check">
    <img class="close-img" src="/../img/ic-m-close.svg" @click="onClick" />
    <div class="modal-title">
      <span>{{ $t("user_menu.setting") }}</span>
    </div>
    <div class="modal-subtitle">
      계정 보호를 위해 비밀번호를 한번 더 입력해주세요.
    </div>
    <div class="row">
      <span>{{ $t("user_info.email") }}</span>
      <input
        type="text"
        v-model="$store.state.user_mail"
        disabled
        @keypress.enter="onSubmit"
        maxlength="50"
      />
    </div>
    <div class="row">
      <span>비밀번호</span>
      <input
        type="password"
        v-model="password"
        placeholder="비밀번호를 입력해주세요."
        @keypress.enter="onSubmit"
      />
    </div>
    <div class="footer">
      <button class="submit" @click="onSubmit">확인</button>
      <button class="cancel" @click="onClick">{{ $t("common.cancel") }}</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "modal-password-check",
  components: {},
  data: function () {
    return {
      email: this.$store.state.user_mail,
      password: "",
    };
  },
  created() {},
  methods: {
    onClick: async function () {
      this.$emit("closeEvent", true);
    },
    onSubmit: async function () {
      if (!this.password) {
        alert(this.$t("help_text.password_input"));
        return;
      }

      const query = {
        email: this.email,
        password: this.password,
      };

      // api 추가
      try {
        const res = await axios.post("/api/user/password/check", query);

        if (res.data.msg === "success") {
          this.$store.commit("setModalProps", {});
          this.$store.commit("setModalType", "user");
        }
      } catch (error) {
        alert("비밀번호가 일치하지 않습니다.");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-password-check {
  margin: auto;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.54);
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  z-index: 4;
  box-sizing: border-box;
  width: 552px;
  // height: 480px;
}
.close-img {
  position: absolute;
  top: 0px;
  cursor: pointer;
  left: 562px;
}
.modal-title {
  width: 100%;
  margin-bottom: 28px;
  span {
    font-size: 18px;
    font-weight: bold;
    color: #000000;
  }
}
.modal-subtitle {
  width: 100%;
  margin-bottom: 28px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
}
@mixin setting-row-grid {
  display: table;
  width: 100%;
  height: 43px;
  margin-bottom: 11px;
  & > span {
    display: table-cell;
    vertical-align: middle;
    font-size: 14px;
    font-weight: bold;
    color: #737373;
  }
  input {
    height: 43px;
    display: block;
    float: right;
    width: 395px;
    border-radius: 10px;
    border: solid 1px #a4a4a4;
    background-color: #ffffff;
    outline: none;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    font-size: 14px;
    text-align: left;
    text-indent: 15px;
    color: #737373;

    &:disabled {
      border: none;
    }
  }
}
.row {
  @include setting-row-grid;
}
.seperate-line {
  margin: 20px 0;
  border: solid 0.5px #e6e6e6;
}
.footer {
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 20px;
  .submit {
    outline: none;
    width: 192px;
    height: 43px;
    border-radius: 20px;
    box-shadow: 0 2px 4px 0 #c6d5e9;
    background-color: #4639de;
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
    margin-left: auto;
    border: none;
  }
  .cancel {
    outline: none;
    width: 192px;
    height: 43px;
    border-radius: 20px;
    box-shadow: 0 2px 4px 0 #c6d5e9;
    background-color: #1c1f28;
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
    margin-left: 13px;
    margin-right: auto;
    border: none;
  }
}
</style>
